var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "mx-auto pa-30 pa-lg-40",
    attrs: {
      "color": "#ddd",
      "max-width": "340",
      "flat": "",
      "tile": "",
      "outlined": ""
    }
  }, [_c('h3', {
    staticClass: "tit tit--sm text-center pb-24"
  }, [_vm._v("사업장")]), _c('v-row', {
    staticClass: "row--xxs"
  }, _vm._l(_vm.workplaces, function (workplace, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "12"
      }
    }, [_c('p', {
      staticClass: "page-text page-text--lg line-height-1"
    }, [_vm._v("· " + _vm._s(workplace.number) + "개 " + _vm._s(workplace.type))])]);
  }), 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }